<!--
  // TODO pendiente avanzar MGP
<app-sales-pay [installment]="installmentsLille" [installmentBig]="installmentsBig" [viewPaymentAdd]="viewPaymentAdd" (step)="onCreateDataStructure($event)"
               *ngIf="step ==stepOptions.pay" />
-->
<div class="fadeinright animation-duration-200" *ngIf="step === stepOptions.selection">
  <div class="px-5 pt-6">
    <div class="flex justify-content-center">
      <h2>{{ '¿En cuántas cuotas deseas dividir el crédito?' | termReplace }}</h2>
    </div>
    <div class="flex flex-column">
      <div class="flex w-full justify-content-center p-3" *ngFor="let quotes of quotesByProduct">
        <p-button severity="secondary" [label]="getLabelProduct(quotes.quota)" (onClick)="onSelectedQuote(quotes)"></p-button>
      </div>
    </div>
  </div>
</div>
